<template>
  <div class="auth-bag"
  :style="`background-image: url('${base_url}/images/login_bg.webp');`">
    <login-card v-show="login_current_content === 'login'"></login-card>
    <register-card v-show="login_current_content === 'register'"></register-card>
    <verification-email v-show="login_current_content === 'verification-email'"></verification-email>
    <forget-password-card v-show="login_current_content === 'forget-password'"></forget-password-card>
    <enter-token-card v-show="login_current_content === 'enter-token'"></enter-token-card>
    <reset-password-card v-show="login_current_content === 'reset-password'"></reset-password-card>
    <privacy-policy v-show="login_current_content === 'privacy-policy'"></privacy-policy>
    <terms-of-service v-show="login_current_content === 'terms-of-service'"></terms-of-service>
  </div>
</template>

<script>
import LoginCard from './auth/LoginCard.vue';
import RegisterCard from './auth/RegisterCard.vue';
import VerificationEmail from './auth/VerificationEmail.vue';
import ForgetPasswordCard from './auth/ForgetPasswordCard.vue';
import EnterTokenCard from './auth/EnterTokenCard.vue';
import ResetPasswordCard from './auth/ResetPasswordCard.vue';
import PrivacyPolicy from './auth/PrivacyPolicy.vue';
import TermsOfService from './auth/TermsOfService.vue';
import { validation } from './mixins/validation.js';

export default {
  components: {
    LoginCard,
    RegisterCard,
    VerificationEmail,
    ForgetPasswordCard,
    EnterTokenCard,
    ResetPasswordCard,
    PrivacyPolicy,
    TermsOfService
  },
  mixins: [validation],
  data() {
    return {
      base_url: base_url,
    }
  },
  computed: {
    login_current_content() {
      return this.$store.getters.loginCurrentContent;
    }
  },
  methods: {
    validateInput(e) {
      this.validation(e.target);
    },
  },
  mounted() {
    this.$el.querySelectorAll('input').forEach((input) => {
      input.addEventListener('blur', this.validateInput);
    });
  }
}
</script>

<style>
* {
  /* outline: 1px rgba(255, 0, 0, 0.247) solid; */
}
</style>

<style>
.auth-bag {
  height: 100vh;
  background-image: url('/images/login_bg.webp');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
  display: flex;
}

.auth-bag a {
  font-weight: bolder;
  color: var(--bx-green);
}

.auth-bag .main-content {
  background-color: white;
  margin: auto;
  width: 25%;
  max-height: 90vh;
  min-width: 350px;
  max-width: 600px;
  padding: 2rem 2rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(92, 99, 105, .2);
}

.auth-bag .main-content .subtitle {
  margin: 1rem 0;
}

.auth-bag .main-content .subtitle > a {
  margin-left: 1rem;
}

.auth-bag .main-content .form-div {
  position: relative;
  height: 2.5rem;
  margin-bottom: 1.5rem;
}

.auth-bag .main-content .form-div .switch-password {
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  color: #80868B;
  font-size: 1.2rem;
  transition: 0.3s;
  z-index: 99;
}

.auth-bag .main-content .form-div .form-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 1rem;
  border: 2px solid #DADCE0;
  border-radius: 0.6rem;
  outline: none;
  padding: 0 1rem;
  background: none;
  z-index: 1;
}

.auth-bag .main-content .form-div .form-input:focus {
  border: 2px solid var(--bx-green);
}

.auth-bag .main-content .form-div .form-input:focus + .form-label {
  top: -0.5rem;
  left: 0.8rem;
  color: var(--bx-green);
  font-size: 0.8rem;
  z-index: 10;
}

.auth-bag .main-content .form-div .form-label {
  position: absolute;
  left: 1rem;
  top: 0.6rem;
  background-color: #fff;
  color: #80868B;
  font-size: 0.9rem;
  transition: 0.3s;
}

.auth-bag .main-content .form-div .is-invalid {
  border-color: red;
}

.auth-bag .main-content .send-bag {
  position: relative;
  height: 4rem;
}

.auth-bag .main-content .send-bag .text-danger {
  position: absolute;
  width: 100%;
  text-align: center;
}

.auth-bag .main-content .send-bag .form-button {
  position: absolute;
  bottom: 0;
  display: block;
  width: 100%;
  line-height: 2.5rem;
  font-weight: bolder;
  outline: none;
  border: none;
  color: #fff;
  font-size: 1rem;
  border-radius: 0.6rem;
  cursor: pointer;
  transition: 0.3s;
}

.auth-bag .main-content .send-bag .form-button:hover {
  box-shadow: 0 10px 36px rgba(0, 0, 0, 0.15);
}

.auth-bag .main-content .login-logo {
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
}

.auth-bag .main-content .login-logo > img {
  width: 60%;
}

.auth-bag .main-content .text-area {
  margin: auto;
  height: 50vh;
  padding: 1rem;
  border-radius: 0.5rem;
  border: solid 1px #dcdbdd;
  background-color: unset;
  overflow-y: auto;
}

.auth-bag .main-content .text-area ul {
  padding-left: 2rem;
  font-size: 0.9rem;
}

.auth-bag .main-content .text-area::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1rem rgba(0, 0, 0, 0.3);
  border-radius: 1.5rem;
}

.auth-bag .main-content .text-area::-webkit-scrollbar {
  width: 0.8rem;
}

.auth-bag .main-content .text-area::-webkit-scrollbar-thumb {
  border-radius: 1.5rem;
  background-color: #818181;
}

.form-input:not(:placeholder-shown).form-input:not(:focus) + .form-label {
  top: -0.5rem;
  left: 0.8rem;
  z-index: 10;
  font-size: 0.8rem;
}
</style>
